import { useState } from "react"
import { Button } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { generarCompraLiquidacionAction, obtenerGruposClaveViajeAction } from "../../../ducks/liquidacionesDuck"
import BackDrop from "../../../global/BackDrop"
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
const BotonValidarLiquidacion = (props) => {
    const { idCuenta, idMoneda, idPaquete } = props
    const { grupo } = useSelector(store => store.liquidaciones)
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)
    const handleClick = () => {
        DialogMessage.fire({
            title: '¿Esta seguro de validar la información de liquidación?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Validando Liquidación..." }))
                dispatch(generarCompraLiquidacionAction({ idCuenta, idMoneda, idPaquete })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema con el servidor",
                        })
                        return null
                    }
                    dispatch(onLoadAnction({ message: "Actualizando Información..." }))
                    dispatch(obtenerGruposClaveViajeAction({ claveViaje: grupo.ClaveViaje })).then(Response => {
                        dispatch(offLoadAction())
                    })
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={handleClick}>
                Validar Liquidación
            </Button>
            <BackDrop open={load} />
        </div>
    )
}
export default BotonValidarLiquidacion